const cart = {
  namespaced: true,
  state: {
    products: localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [],
    error: localStorage.getItem("cartError") || "",
    selectedCustomer: "",
    selectedAnbar: "",
    orderId: "",
    detailCustomer: "",
    detailCart: [],
    searchResults: [],
  },
  mutations: {
    SET_SEARCH_RESULT(state, results) {
      state.searchResults = results;
      console.log(state.searchResults);
    },
    ADD_PRODUCT(state, product) {
      state.products.push(product);
    },
    INCREMENT_PRODUCT_COUNT(state, index) {
      state.products[index].quantity += 1;
    },
    INCREMENT_PRODUCT_MULTI_COUNT(state, { index, count }) {
      state.products[index].quantity += count;
    },
    REMOVE_PRODUCT(state, product) {
      let index = state.products.findIndex(
        (item) => product.kala_Code === item.kala_Code
      );
      if (state.products[index].quantity > 0) {
        state.products[index].quantity -= 1;
        if (state.products[index].quantity === 0) {
          state.products.splice(index, 1);
        }
      }
      this.commit("SAVE_CART");
    },
    SAVE_CART(state) {
      localStorage.setItem("cart", JSON.stringify(state.products));
    },
    ADD_CART_ERROR(state, error) {
      state.error = error;
      localStorage.setItem("cartError", error);
    },
    REMOVE_CART_ERROR(state) {
      state.error = "";
      localStorage.removeItem("cartError");
    },
    CHANGE_CART(state, cart) {
      state.products = cart;
      this.commit("SAVE_CART");
    },
    EMPTY_CART(state) {
      state.products = [];
      state.error = "";
      localStorage.setItem("cart", JSON.stringify(state.products)); // ذخیره مقدار جدید خالی
      localStorage.setItem("cartError", state.error); // ذخیره مقدار جدید خطا
    },

    SHOWDEATILCART(state, detail) {
      state.detailCart.push(detail);
      console.log(state.detailCart);
    },

    // EMPTY_CART(state) {
    //   state.products = [];
    //   this.error = "";
    //   localStorage.setItem("cartError", this.error);
    //   this.commit("SAVE_CART");
    // },
    SELECTES_COSTOMER(state, selCustomer) {
      state.selectedCustomer = [];
      localStorage.setItem("selectedCustomer", selCustomer);
      state.selectedCustomer.push(selCustomer);
    },
    SELECTES_ANBAR(state, selAnbar) {
      state.selectedAnbar = [];
      state.selectedAnbar.push(selAnbar);
    },
    ORDERID(state, id) {
      state.orderId = [];
      state.orderId.push(id);
    },
    INSERTDETAIL(state, detail) {
      state.detailCustomer = [];
      state.detailCustomer.push(detail);
      //localStorage.setItem("detailCustomer", JSON.stringify(state.detailCustomer));
    },
  },
  actions: {
    // we check the validation in action so we can return Promise.reject() on error (we cant use promise in mutations)
    addProduct({ commit, state }, product) {
      const index = state.products.findIndex(
        (item) => item.kala_Code === product.kala_Code
      );
      const searchResult = localStorage.getItem("SearchResults") === "true";

      if (index > -1) {
        const existingProduct = state.products[index];
        const newQuantity = existingProduct.quantity + 1;
        const maxByMojodi = product.mojodi / product.pack_Value;

        // بررسی موجودی
        if (newQuantity > maxByMojodi) {
          return Promise.reject(`موجودی این کالا ${maxByMojodi} است.`);
        }

        // بررسی ظرفیت سفارش
        if (newQuantity > product.max_Order_Capacity) {
          return Promise.reject(
            `بیشترین مقدار سفارش این کالا ${product.max_Order_Capacity} است.`
          );
        }

        // بررسی محدودیت بسته‌ها
        if (
          searchResult &&
          existingProduct.maxpackage > 0 &&
          newQuantity > existingProduct.maxpackage
        ) {
          return Promise.reject(
            `تعداد بسته‌های مجاز برای این کالا ${existingProduct.maxpackage} است.`
          );
        }

        // در صورت عبور از هیچ محدودیتی، مقدار را افزایش بده
        commit("INCREMENT_PRODUCT_COUNT", index);
        commit("SAVE_CART");
      } else {
        if (
          searchResult &&
          product.maxpackage > 0 &&
          product.quantity + 1 > product.maxpackage
        ) {
          return Promise.reject(
            `تعداد بسته‌های مجاز برای این کالا ${product.maxpackage} است.`
          );
        } else {
          product.quantity = 1;
          commit("ADD_PRODUCT", product);
          commit("SAVE_CART");
        }
      }
    },
    editProduct({ commit, state }, product) {
      let index = state.products.findIndex(
        (item) => product.kala_Code === item.kala_Code
      );
      if (index > -1) {
        if (
          state.products[index].quantity + 1 >
          product.mojodi / product.pack_Value
        ) {
          return Promise.reject(
            `موجودی این کالا ${
              state.products[index].mojodi / product[index].pack_Value
            } است.`
          );
        } else {
          // After Inventory, we Check Max Order Capacity
          if (state.products[index].quantity + 1 > product.max_Order_Capacity) {
            return Promise.reject(
              `بیشترین مقدار سفارش این کالا ${state.products[index].max_Order_Capacity} است.`
            );
          } else {
            commit("INCREMENT_PRODUCT_COUNT", index);
          }
        }
      } else {
        //product.quantity = 1;
        commit("ADD_PRODUCT", product);
      }
    },
    addCountProduct({ commit, state }, { product, count }) {
      const searchResult = localStorage.getItem("SearchResults") === "true";
      const index = state.products.findIndex(
        (item) => item.kala_Code === product.kala_Code
      );

      // بررسی اعتبار تعداد
      if (!count || isNaN(count) || count <= 0) {
        return Promise.reject("تعداد وارد شده معتبر نیست.");
      }

      const maxByMojodi = product.mojodi / product.pack_Value;

      if (index > -1) {
        const existingProduct = state.products[index];
        const newQuantity = existingProduct.quantity + count;

        // بررسی موجودی
        if (newQuantity > maxByMojodi) {
          return Promise.reject(`موجودی این کالا ${maxByMojodi} است.`);
        }

        // بررسی ظرفیت سفارش
        if (newQuantity > product.max_Order_Capacity) {
          return Promise.reject(
            `بیشترین مقدار سفارش این کالا ${product.max_Order_Capacity} است.`
          );
        }

        // بررسی محدودیت بسته‌ها
        if (
          searchResult &&
          existingProduct.maxpackage > 0 &&
          newQuantity > existingProduct.maxpackage
        ) {
          return Promise.reject(
            `تعداد بسته‌های مجاز برای این کالا ${existingProduct.maxpackage} است.`
          );
        }

        // در صورت عبور از هیچ محدودیتی، مقدار را افزایش بده
        commit("INCREMENT_PRODUCT_MULTI_COUNT", { index, count });
      } else {
        // وقتی کالا در لیست وجود ندارد
        if (count > maxByMojodi) {
          return Promise.reject(`موجودی این کالا ${maxByMojodi} است.`);
        }

        if (count > product.max_Order_Capacity) {
          return Promise.reject(
            `بیشترین مقدار سفارش این کالا ${product.max_Order_Capacity} است.`
          );
        }

        if (
          searchResult &&
          product.maxpackage > 0 &&
          count > product.maxpackage
        ) {
          return Promise.reject(
            `تعداد بسته‌های مجاز برای این کالا ${product.maxpackage} است.`
          );
        }

        const newProduct = { ...product, quantity: count };
        commit("ADD_PRODUCT", newProduct);
      }
    },

    removeProduct({ commit }, product) {
      commit("REMOVE_PRODUCT", product);
    },
    addCartError({ commit }, error) {
      commit("ADD_CART_ERROR", error);
    },
    removeCartError({ commit }) {
      commit("REMOVE_CART_ERROR");
    },
    changeCart({ commit }, cart) {
      commit("CHANGE_CART", cart);
    },
    emptyCart({ commit }) {
      commit("EMPTY_CART");
    },
    selectedCustomer({ commit }, selCustomer) {
      commit("SELECTES_COSTOMER", selCustomer);
    },
    selectedAnbar({ commit }, selAnbar) {
      commit("SELECTES_ANBAR", selAnbar);
    },
    orderId({ commit }, id) {
      commit("ORDERID", id);
    },
    insertDetail({ commit }, detail) {
      commit("INSERTDETAIL", detail);
    },
    showDeatilCart({ commit }, detail) {
      commit("SHOWDEATILCART", detail);
      console.log("اکشن showDeatilCart فراخوانی شد با داده:", detail);
    },
  },
  getters: {
    getCustomerById: (state) => (id) => {
      return state.searchResults.find((item) => item.customerId === id);
    },
    productCount: (state) => (id) => {
      console.log(id);
      const product = state.products.find(
        (product) => product.kala_Code === id
      );
      if (product) {
        return product.quantity;
      }
      console.log(product);
      return 0;
    },
    totalPriceBeforeDiscount(state) {
      let price = 0;
      state.products.forEach((product) => {
        price += product.quantity * product.salE_NERKH * product.pack_Value;
      });

      return price / 10;
    },
    totalPriceAfterDiscount(state) {
      let price = 0;
      state.products.forEach((product) => {
        price += product.quantity * product.nerkH_WITH_TAX * product.pack_Value;
      });

      return price / 10;
    },
    profit(state, getters) {
      return getters.totalPriceBeforeDiscount - getters.totalPriceAfterDiscount;
    },
    cartCount(state) {
      return state.products.length;
    },
    isCartEmpty(state) {
      return state.products.length === 0;
    },
    detailCart: (state) => state.detailCart,
  },
};

export default cart;
